import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import { getCurrencyLabel } from '../../../conf/chargify';
import LoadingAnimation from '../../LoadingAnimation';
import PlanCard from '../PlanCard';
import { useStyles } from './pricingSection.styles';

function PricingSection ({
    plans,
    loading,
    currency,
    accentColor,
    currentPlanId,
    onChoosePlan,
    ctaLabel,
    ctaLabelPrefix,
    header,
    defaultAddOnsExpanded,
    cardWidth,
    cardGap,
    layout,
}) {
    const classes = useStyles({ accentColor, cardWidth, cardGap, layout });
    const [addOnsExpanded, setAddOnsExpanded] = useState(defaultAddOnsExpanded);

    function toggleAddOns () {
        setAddOnsExpanded((prev) => !prev);
    }

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
                <LoadingAnimation />
            </div>
        );
    }

    if (!plans.length) {
        return null;
    }

    return (
        <div>
            {header && (
                <div className={classes.header}>
                    <Typography variant="h4" className={classes.headerTitle}>
                        {header.title}
                    </Typography>
                    {header.subtitle && (
                        <Typography variant="body1" className={classes.headerSubtitle}>
                            {header.subtitle}
                        </Typography>
                    )}
                </div>
            )}

            <div className={classes.cards}>
                {plans.map((plan) => (
                    <PlanCard
                        key={plan.code}
                        plan={plan}
                        accentColor={accentColor}
                        // currentPlanId is matched against id, code, or name
                        // ECAL plans identify the current plan by id, Connect plans by code
                        isCurrent={!!currentPlanId && (plan.id === currentPlanId || plan.code === currentPlanId || plan.name === currentPlanId)}
                        onChoosePlan={onChoosePlan}
                        addOnsExpanded={addOnsExpanded}
                        onToggleAddOns={toggleAddOns}
                        ctaLabel={ctaLabel}
                        ctaLabelPrefix={ctaLabelPrefix}
                    />
                ))}
            </div>

            <Typography variant="caption" className={classes.footerNote}>
                {`All prices in ${getCurrencyLabel(currency)}, excl. tax. Monthly billing. Cancel anytime.`}
            </Typography>
        </div>
    );
}

PricingSection.propTypes = {
    plans: PropTypes.array,
    loading: PropTypes.bool,
    currency: PropTypes.string,
    accentColor: PropTypes.string,
    currentPlanId: PropTypes.string,
    onChoosePlan: PropTypes.func.isRequired,
    ctaLabel: PropTypes.string,
    ctaLabelPrefix: PropTypes.string,
    header: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
    }),
    defaultAddOnsExpanded: PropTypes.bool,
    cardWidth: PropTypes.number,
    cardGap: PropTypes.number,
    layout: PropTypes.oneOf(['fixed', 'responsive']),
};

PricingSection.defaultProps = {
    plans: [],
    loading: false,
    currency: '',
    accentColor: null,
    currentPlanId: null,
    ctaLabel: '',
    ctaLabelPrefix: 'CHOOSE',
    header: null,
    defaultAddOnsExpanded: false,
    cardWidth: 400,
    cardGap: 24,
    layout: 'fixed',
};

export default PricingSection;
